import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { activeId: String }

  connect() {
    // Check URL on initial load for direct navigation
    this.highlightFromUrl()

    // Wire up the shared delete confirmation button
    this._confirmBtn = document.getElementById('confirm-delete-conversation')
    if (this._confirmBtn) {
      this._onConfirm = () => this._performDelete()
      this._confirmBtn.addEventListener('click', this._onConfirm)
    }
  }

  disconnect() {
    if (this._confirmBtn && this._onConfirm) {
      this._confirmBtn.removeEventListener('click', this._onConfirm)
    }
  }

  highlightFromUrl() {
    const match = window.location.pathname.match(/\/conversations\/(\d+)/)
    if (match) {
      this.activeIdValue = match[1]
      this.updateActiveClass()
    }
  }

  updateActiveClass() {
    // Remove active class from all cards
    document.querySelectorAll(".conversation-card").forEach(card => {
      card.classList.remove("conversation-card-active")
    })

    // Add active class to matching card
    if (this.activeIdValue) {
      const activeCard = document.querySelector(`a.conversation-card[href="/conversations/${this.activeIdValue}"]`)
      if (activeCard) {
        activeCard.classList.add("conversation-card-active")
      }
    }
  }

  select(event) {
    // Find the conversation card element (could be event.target or a parent)
    const card = event.target.closest(".conversation-card")
    if (!card) return

    // Remove unread styling immediately when clicked
    card.classList.remove("conversation-card-unread")

    // Remove active class from all cards and add to clicked card
    document.querySelectorAll(".conversation-card").forEach(c => {
      c.classList.remove("conversation-card-active")
    })
    card.classList.add("conversation-card-active")
  }

  showDeleteModal(event) {
    event.preventDefault()
    event.stopPropagation()
    const btn = event.currentTarget
    this._pendingDeleteUrl = btn.dataset.hideUrl
    this._pendingDeleteCard = btn.closest('.conversation-card-wrapper')
    const modalEl = document.getElementById('modal_delete_conversation')
    if (modalEl) $(modalEl).modal('show')
  }

  _performDelete() {
    if (!this._pendingDeleteUrl) return
    const url = this._pendingDeleteUrl
    const card = this._pendingDeleteCard
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    const modalEl = document.getElementById('modal_delete_conversation')
    if (modalEl) $(modalEl).modal('hide')

    // Check if the deleted conversation is currently being viewed
    const cardLink = card?.querySelector('a.conversation-card')
    const cardHref = cardLink?.getAttribute('href') || ''
    const isViewing = window.location.pathname === cardHref || window.location.pathname.startsWith(cardHref + '/')

    fetch(url, {
      method: 'DELETE',
      headers: { 'X-CSRF-Token': csrfToken, 'Accept': 'application/json' }
    }).then(response => {
      if (response.ok && card) {
        card.remove()
        if (isViewing) this._resetDetailPane()
      }
    }).catch(() => {})

    this._pendingDeleteUrl = null
    this._pendingDeleteCard = null
  }

  _resetDetailPane() {
    const detailFrame = document.getElementById('conversation-detail')
    if (detailFrame) {
      detailFrame.removeAttribute('src')
      detailFrame.innerHTML = `
        <div class="conversation-detail-empty">
          <div class="text-center">
            <i class="fa-regular fa-comments d-block mb-3" style="font-size: 64px; color: rgba(0, 0, 0, 0.1);"></i>
            <p class="mb-0 font-16" style="color: #727272;">Open a chat or <a href="/conversations/new" class="fw-semibold text-decoration-none" style="color: #4168FF;" data-remote="true">start a new conversation</a></p>
          </div>
        </div>
      `
    }
    history.replaceState({}, '', '/conversations')
  }
}
